





















import {Vue, Component, Watch} from 'vue-property-decorator';
import SearchStore from '@/store/SearchStore.brain';
import DetailStore from '@/store/DetailStore';
import BrainHeader from './header/brain-header.vue';
import BrainContent from './brain-content.vue';
import qsObj from '../../../utils/qs.js';
import qs from 'qs';

@Component({
    components: {BrainHeader, BrainContent}
})
export default class App extends Vue {
    searchData = SearchStore.state;
    detailData = DetailStore.state;
    cancelToken: any;
    aef: any;
    animation = autoAnimation ? 'fly-out' : 'fly-in';
    fetchDataPromise: any;
    fetchDataSuccess: any;
    keydownListener = null;

    created () {
        this.fetchDataPromise = new Promise(resolve => this.fetchDataSuccess = resolve)
    }

    *actionScriptGraph2d (isQuick) {
        yield this.$sleep(0);
        this.animation = 'fly-in';
        yield this.fetchDataPromise; // 确保数据已经获取完毕了
        // 两种脚本： 一是只保留左右两侧的动效；二是左右两侧和中间图谱都有动效
        if (isQuick) {
            // 第二个参数为true, 代表只保留左右两侧的动效
            yield this.$bus.$emit('brain-content', isQuick, true);
        } else {
            yield this.$bus.$emit('brain-content')
        }
        // yield this.$bus.$emit('brain-content', isQuick);
        if ($qsObj.jumpnext === 'false') {return void 0;}
        if (!isQuick) {
            const queryObj = qs.parse(location.search.slice(1));
            if (queryObj.goto) {
                location.pathname = 'case';
            } else {
                this.$bus.$emit('view-change', '2d', '3d');
                DetailStore.reset2dData(); // 离开后要清空2d数据
            }
        }
    }

    // 2d从远端获取数据
    async initFetchData() {
        let defaultPoi = $qsObj.s || $foodConfig.poi2dSearch;
        let city = $qsObj.city || $foodConfig.poi2dSearchCity;
        // await SearchStore.search(defaultPoi); // 这里开始请求数据
        await SearchStore.searchCES(defaultPoi, false, false, city); // 这里开始请求数据
        let {subjectId, entityType} = this.searchData.searchItem;

        DetailStore.getStatistic(subjectId);
        if (entityType === 'user') {
            await Promise.all([
                DetailStore.getUserDataBySubjectId(subjectId),
                DetailStore.getUserGraph({subjectId}),
            ]);
        } else if (entityType === 'poi') {
            await Promise.all([
                DetailStore.getPoiDataBySubjectId(subjectId),
                DetailStore.getPoiGraph({subjectId}),
            ])
        }
        this.fetchDataSuccess(); // resolve Data
    }

    async fetchShanghaiData(defaultPoi = '眉州东坡（久光中心店）', city = '上海') {
        // let defaultPoi = '眉州东坡上海中心';
        // let city = '上海';
        await SearchStore.searchCES(defaultPoi, false, true, city); // 这里开始请求数据
        let {subjectId, entityType} = this.searchData.searchItem;
        DetailStore.getStatistic(subjectId);
        if (entityType === 'user') {
            await Promise.all([
                DetailStore.getUserDataBySubjectId(subjectId),
                DetailStore.getUserGraph({subjectId}),
            ]);
        } else if (entityType === 'poi') {
            await Promise.all([
                DetailStore.getPoiDataBySubjectId(subjectId),
                DetailStore.getPoiGraph({subjectId}),
            ])
        }
        this.fetchDataSuccess(); // resolve Data
    }


    destroyed () {
        DetailStore.reset2dData(); // 离开后要清空2d数据
    }

    //快捷键快速访问
    keydownListenerMemoize() {
        let tmp;
        return (e) => {
            if (e.target && (e.target as any).tagName && e.target.tagName.toLowerCase() === 'input') {
                return
            }
            let key = e.key.toLowerCase();
            console.log('brain-container-2d.vue:key', key);
            if ( key === 'c' ) {
                tmp = key;
            } else {
                tmp += key;
            }
            if (tmp === 'c1') {
                this.$bus.$emit('view-change', '2d', '3d');
            }

            if (tmp === 'cp') {
                this.fetchShanghaiData()
            }
            if (tmp === 'ct') {
                this.fetchShanghaiData('黔诚酸汤牛肉', '贵阳')
            }
            if (tmp === 'cs') {
                this.fetchShanghaiData('点都德', '深圳')
            }
        }
    }

    beforeDestroy() {
        document.removeEventListener('keydown', this.keydownListener);
    }

    mounted () {
        this.cancelToken = new this.$ae.CancelToken();
        this.aef = this.$ae(this.actionScriptGraph2d, this.cancelToken);

        this.initFetchData();
        const queryObj = qs.parse(location.search.slice(1));
        if (qsObj.view === '2d' && queryObj.auto) {
            this.aef(false);
        } else {
            this.$autoOn('2d-start', this.aef);
        }

        this.$autoOn('action-script-stop', () => {
            this.cancelToken.abort();
        });

        this.$autoOn('action-script-start', () => {
            this.cancelToken = null;
        });


        this.keydownListener = this.keydownListenerMemoize();
        document.addEventListener('keydown', this.keydownListener);
    }
}
